jQuery(document).ready(function ($) {

	'use strict';

	// After ajax request
	$(document).ajaxStop(function () {

		/**
		 * If the user is on a /app/ endpoint, filter all post urls by adding missing /app/ endpoints 
		 */
		if ($('.posts_group').length) {
			var url = window.location.href.replace(/\/$/, '');
			var array = url.split('/');
			var urlEndpoint = array[array.length - 1];
			if (urlEndpoint === 'app') {
				$('.posts_group .post-item a').each(function (index) {
					var $this = $(this);
					var linkHref = $this.attr('href').replace(/\/$/, '');
					var linkArray = linkHref.split('/');
					var linkEndpoint = linkArray[linkArray.length - 1];
					if (linkEndpoint !== 'app') $this.attr('href', linkHref + '/app/');
				});
			}
		}

	});

});